import { THEME_MODE } from '../actionCreators/actionTypes';

const themeReducer = (state = true, action) => {
    if (action.type === THEME_MODE) return action.payload;
    return state;
};

export default themeReducer;
